<template>
  <div
    :key="uniqueKey" class="rich-text"
    :style="{
      width: config.chartWidth,
      height: config.chartHeight,
      fontSize: '22px',
    }">
    <div
      id="editable"
      ref="editable"
      class="rich-text-block">
    </div>
    <div v-if="options.disableEditing" class="editable-mask" @dblclick="handleDoubleClick" />
  </div>
</template>

<script>
import MediumEditor from 'medium-editor'

export default {
  name: 'RichTextBlock',
  props: {
    config: {
      type: Object,
    },
    globalConfig: {
      type: Object,
    },
    componentType: {
      type: String,
    },
  },
  data () {
    return {
      disableEdit: true,
      uniqueKey: 'xxx',
      options: {
        toolbar: false,
        disableEditing: true,
        // 锚点
        anchor: {
          placeholderText: 'Paste or type a link',
          customClassOption: 'btn',
          customClassOptionText: 'Create Button',
        },
        placeholder: {
          text: this.config.chartViewData?.chartData ? '' : '双击即可输入',
          hideOnClick: false,
        },

      },
      editor: null,

    }
  },
  computed: {
    isActive () {
      return this.config.active
    },
    fontColor () {
      return this.config.chartSet.titleStyle.color
    },

    bold () {
      return this.config.chartSet.titleStyle.fontStyle.bold
    },
    italic () {
      return this.config.chartSet.titleStyle.fontStyle.italic
    },
    underline () {
      return this.config.chartSet.titleStyle.fontStyle.underline
    },
    strikeThrough () {
      return this.config.chartSet.titleStyle.fontStyle.strikeThrough
    },
    color () {
      return this.config.chartSet.titleStyle.fontStyle.color
    },
    fontSize () {
      return this.config.chartSet.titleStyle.fontStyle.fontSize
    },

    fontAlign () {
      return this.config.chartSet.titleStyle.align
    },
  },
  watch: {
    isActive (val) {
      if (!val) {
        // 非激活
        this.config.draggable = true
      }
      this.options.disableEditing = true
      this.updateEditor()
      this.config.chartViewData.chartData = this.editor.serialize().editable.value
    },
    fontColor: {
      handler (val) {
        this.handleChangeStyle('ForeColor', this.fontColor)
      },
    },

    fontSize: {
      handler (val) {
        this.handleChangeStyle('FontSize', this.config.chartSet.titleStyle.fontSize)
      },
    },
    bold (val, oldVal) {
      this.handleChangeStyle('bold')
    },
    italic (val, oldVal) {
      this.handleChangeStyle('italic')
    },
    underline (val, oldVal) {
      this.handleChangeStyle('underline')
    },
    strikeThrough (val, oldVal) {
      this.handleChangeStyle('strikeThrough')
    },
    color (val, oldVal) {
      this.handleChangeStyle('foreColor', this.config.chartSet.titleStyle.color)
      this.$nextTick(() => {
        this.config.chartViewData.chartData = this.editor.serialize().editable.value
      })
    },

    fontAlign: {
      handler (newValue, oldValue) {
        const map = {
          left: 'JustifyLeft',
          center: 'JustifyCenter',
          right: 'JustifyRight',
        }
        this.handleChangeStyle(map[this.fontAlign])
      },

    },
  },
  created () {
    this.uniqueKey = Math.random()
  },

  mounted () {
    this.editor = new MediumEditor(this.$refs.editable, this.options)
    this.$refs.editable.innerHTML = this.config.chartViewData.chartData
  },
  methods: {
    updateEditor () {
      this.editor.destroy()
      this.editor = new MediumEditor(this.$refs.editable, this.options)

      // 失焦时恢复拖拽
      this.editor.subscribe('editableBlur', (e, editor) => {
        // 失焦时保存选中文本
        this.editor.saveSelection()
        this.editor.restoreSelection()
        this.$nextTick(() => {
          this.config.chartViewData.chartData = this.editor.serialize().editable.value
        })
      })
    },

    handleDoubleClick () {
      this.options.disableEditing = false
      this.updateEditor()
      this.editor.origElements.focus()
      this.config.draggable = false
    },
    handleChangeStyle (item, style) {
      //  获取选中内容
      const selectContent = MediumEditor.selection.getSelectionHtml(this.editor.options.ownerDocument)
      // editor 文本内容
      const editorContent = this.editor.serialize().editable.value
      if (!selectContent && editorContent) {
        this.handleDoubleClick()
        this.editor.selectAllContents()
      }
      this.editor.options.ownerDocument.execCommand('styleWithCSS', null, true)
      this.editor.options.ownerDocument.execCommand(item, false, style)
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-text {
  position: relative;
  width: 100%;
  height: 100%;
  .rich-text-block{
    cursor: default;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 5px;
    color: #fff;
    &:focus-visible {
      outline: none;
    }
  }
  .editable-mask{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

}

</style>
